export default __webpack_public_path__ + "static/11-multiple-property-250e9fba0f9b2de84baea2ddd3f08ba3.png";